import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import React, { useEffect, useState, useRef } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import CheckIcon from "@mui/icons-material/Check";
import PinModal from "../Modals/PinModal";
import ConfirmBox from "../UserInteractive/ConfirmBox";
import { Autocomplete } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import { setBookList, setCharList, serRachiytaList, setKirtanList, setBhavList } from "../../Slice/formSlice";
import { Editor } from "@tinymce/tinymce-react";
import { gujUnicodeToEnglish, sulekhToGujUnicodeConverter } from "../../services/converter.service";
import api from "../../Utils/Interceptor";

const content_style = `
@font-face {
  font-family: "Guj_Gopika_Two_Bold";
  src: url("./fonts/Guj_Gopika_Two_Bold.ttf") format("truetype");
}

@font-face {
  font-family: "Hin_CC-Devnagri_Bold_SULEKH";
  src: url("./fonts/H-devb_1.ttf") format("truetype");
}

@font-face {
  font-family: "AA_Sanskrut_Jodaxar_B_SULEKH";
  src: url("./fonts/SanjodaB.ttf") format("truetype");
}

@font-face {
  font-family: "Ghanu_unicode_Guj";
  src: url("./fonts/Ghanu-Regular.ttf") format("truetype");
}

@font-face {
  font-family: "Ghanu_unicode_bold_Guj";
  src: url("./fonts/GhanuTest-Bold.ttf") format("truetype");
}

@font-face {
  font-family: "Gyan_Uni_Bold_Hindi";
  src: url("./fonts/Gyan_Uni_Bold.ttf") format("truetype");
}

@font-face {
  font-family: "UH002 SanskritText-Regular";
  src: url("./fonts/UH002\ SanskritText-Regular.ttf") format("truetype");
}

@font-face {
  font-family: "UH002 SanskritText-Bold";
  src: url("./fonts/UH002\ SanskritText-Bold.ttf") format("truetype");
}

                    body {
                        font-family: monospace;
                        font-size: 23px;
                    }`;
const defaultValues = {
  kirtan_title: "",
  kirtan_tittle_unicode: "",
  kirtan_title_english: "",
  kirtan_content_english: "",
  kirtan_content_unicode: "",
  kirtan_content: "",
  book_name: "Kirtanmala-1",
  char_name: "અ",
  raag_name: "",
  dhal_name: "",
  rachiyta_name: "Not Available",
  seq_number: "",
  page_number: "",
  pad_number: "1",
  parent_pad_name: "Not Available",
  bhav_name_JSON: [],
};
const schema = yup.object().shape({
  kirtan_title: yup.string().required("You must enter a title"),
  kirtan_tittle_unicode: yup.string().required("You must enter a title"),
  kirtan_title_english: yup.string().required("You must enter a title"),
  kirtan_content: yup.string().required("You must enter a content"),
  kirtan_content_unicode: yup.string().required("You must enter a content"),
  kirtan_content_english: yup.string().required("You must enter a content"),
  book_name: yup.string().required("You must select book name"),
  char_name: yup.string().required("You must select book name"),
  rachiyta_name: yup.string().required("You must select book name"),
  seq_number: yup.string().required("You must enter sequence number"),
  page_number: yup.string().required("You must enter page number"),
  pad_number: yup.string("Pad number should be a number").nullable().optional(),
  parent_pad_name: yup.string().optional().nullable(),
  bhav_name_JSON: yup.array().required("Select bhav name"),
  dhal_name: yup.string().optional().nullable(),
  raag_name: yup.string().optional().nullable(),
});

const DatabaseForm = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  let { state } = useLocation();

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    getValues,
    setValue,
    clearErrors,
    watch,
  } = useForm({
    mode: "onSubmit",
    defaultValues,
    resolver: yupResolver(schema),
  });

  // const watchedValues = watch();
  const watchBookName = watch("book_name");

  const [bookId, setBookId] = useState(1);

  const localTinyMCEScriptSrc = `${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`;

  const [buttonWidth, setButtonWidth] = useState(0);

  const buttonRef = useRef(null);

  const [editorInitialValue, setEditorInitialValue] = useState("");

  const [parentKirtanTitleFilter, setParentKirtanTitleFilter] = useState();

  const [updateKirtanFlag, setUpdateKirtanFlag] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const [updateKirtanId, setUpdateKirtanId] = useState();

  const [bhavNameArr, setBhavNameArr] = useState([]);

  const [openPin, setOpenPin] = useState(false);

  const [create, setCreate] = useState(true);

  const [dataSetValue, setDataSetValue] = useState();

  const isOnlySavePage = window.location.pathname.split("/")[1] === "save-form";

  const [latestSeqObj, setLatestSeqObj] = useState({});

  const bookList = useSelector((state) => state.FormList.book_list);
  const charList = useSelector((state) => state.FormList.char_list);
  const rachiytaList = useSelector((state) => state.FormList.rachiyta_list);
  const kirtanList = useSelector((state) => state.FormList.kirtan_list);
  const bhavList = useSelector((state) => state.FormList.bhav_list);
  const APIurl = useSelector((state) => state.db.url);
  const open = Boolean(anchorEl);

  const [showHomeScreenConfirm, setShowHomeScreenConfirm] = useState(false);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleShowHomeScreenConfirm = (value) => {
    setShowHomeScreenConfirm(value);
  };

  const handleShowCancelConfirm = (value) => {
    setShowCancelConfirm(value);
  };

  const handleShowDeleteConfirm = (value) => {
    setShowDeleteConfirm(value);
  };

  const handlePinModal = (value) => {
    setOpenPin(value);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleParentKirtanTitleFilter = (event) => {
    event.stopPropagation();
    setParentKirtanTitleFilter(event.target.value);
  };

  const apiParentName = async (parent_pad_name) => {
    const parentPadIdURL = `${APIurl}/api/kirtan/parentPad`;
    const postBody = {
      title: parent_pad_name,
      book_id: bookId,
    };
    const authToken = sessionStorage.getItem("token");
    const data = await axios
      .post(parentPadIdURL, postBody, {
        headers: {
          Authorization: authToken ? `Bearer ${authToken}` : "",
        },
      })
      .then((response) => {
        return response.data;
      })
      .then(async (data) => {
        return data.data;
      })
      .catch((error) => {
        console.log(error);
      });
    return data;
  };

  const findBookName = (id) => {
    const book = bookList?.find((book) => book.id === id);
    return book ? book.name : null;
  };

  const handlePadNameFromId = async (id) => {
    const url = `${APIurl}/api/kirtan/id/${id}`;
    const res = await api.get(url);
    const kirtanById = res.data.data;
    return kirtanById ? kirtanById.title : "Not Available";
  };

  const findParentPadName = async (id) => {
    if (id) {
      const parentKirtan = await handlePadNameFromId(id);
      return parentKirtan ? parentKirtan : "Not Available";
    } else {
      return "Not Available";
    }
  };

  const findLatestSeqTitle = async (bookId) => {
    const sqeURL = `${APIurl}/api/kirtan/last_seq/${bookId}`;
    const seqRes = await api.get(sqeURL);
    const kirtanById = seqRes.data.data;
    setLatestSeqObj(kirtanById ? kirtanById : { seq_id: 0, book_id: bookId, title: "કીર્તન ઉપલબ્ધ નથી" });
  };

  const findCharName = (id) => {
    const char = charList?.find((char) => char.id === id);
    return char ? char.guj_char : null;
  };

  const findRachiytaName = (id) => {
    const rachiyta = rachiytaList?.find((rachiyata) => rachiyata.id === id);
    return rachiyta ? rachiyta.name : null;
  };

  const findBhavNameArr = (arr) => {
    const bhavNameArr = arr.map((id) => {
      const bhav = bhavList?.find((obj) => obj.id === id);
      return bhav ? bhav.bhav_name : null;
    });
    return bhavNameArr ? bhavNameArr : ["Mahima"];
  };

  const findBookId = (book_name) => {
    let name = book_name || "extra";
    const book = bookList?.find((book) => book.name === name);
    return book ? +book.id : null;
  };

  const findParentPadId = async (parent_pad_name) => {
    const kirtanParentName = await apiParentName(parent_pad_name);
    return kirtanParentName ? kirtanParentName.id : null;
  };

  const findCharId = (char_name) => {
    let name = char_name || "extra";
    const char = charList?.find((char) => char.guj_char === name);
    return char ? +char.id : null;
  };

  const findRachiytaId = (rachiyta_name) => {
    let name = rachiyta_name || "extra";
    const rachiyta = rachiytaList?.find((rachiyata) => rachiyata.name === name);
    return rachiyta ? +rachiyta.id : null;
  };

  const findBhavIdArr = (bhavNameArr) => {
    const bhavIdArr = bhavNameArr.map((bhavName) => {
      const bhavObject = bhavList.find((obj) => obj.bhav_name === bhavName);
      return bhavObject ? bhavObject.id : null;
    });
    return bhavIdArr ? bhavIdArr : [];
  };

  const showAlertToast = (type, message) => {
    switch (type) {
      case "warn":
        toast.warn(message);
        break;
      case "success":
        toast.success(message);
        break;
      case "error":
        toast.error(message);
        break;
      case "Alert":
        toast.alert(message);
        break;
      default:
    }
  };

  const handleSulechTitileChange = async (value) => {
    setValue("kirtan_title", value);
    clearErrors("kirtan_title");
    clearErrors("kirtan_tittle_unicode");
    const unicodeValue = sulekhToGujUnicodeConverter(value);
    setValue("char_name", unicodeValue[0]);
    const englishValue = gujUnicodeToEnglish(unicodeValue);
    setValue("kirtan_tittle_unicode", unicodeValue);
    setValue("kirtan_title_english", englishValue);
  };

  const handleSulechContentChange = (editor) => {
    clearErrors("kirtan_content");
    clearErrors("kirtan_content_unicode");
    const unicodeContentValue = sulekhToGujUnicodeConverter(editor.getContent({ format: "text" }));
    const englishContentValue = gujUnicodeToEnglish(unicodeContentValue);
    setValue("kirtan_content_unicode", unicodeContentValue.replace(/અા/g, "આ").replace(/અો/g, "ઓ").replace(/અે/g, "એ").replace(/જાે/g, "જો"));
    setValue("kirtan_content_english", englishContentValue);
    setValue(
      "kirtan_content",
      editor.getContent({ format: "html" }).replace(/અા/g, "આ").replace(/અો/g, "ઓ").replace(/અે/g, "એ").replace(/જાે/g, "જો"),
    );
  };

  const handleCancel = () => {
    state.flag = false;
    reset(defaultValues);
    setEditorInitialValue(defaultValues.kirtan_content);
    setUpdateKirtanFlag(false);
    setUpdateKirtanId(null);
    handleShowCancelConfirm(false);
  };

  const handleHome = () => {
    navigate("/");
    reset(defaultValues);
    setEditorInitialValue(defaultValues.kirtan_content);
    setUpdateKirtanFlag(false);
    setUpdateKirtanId(null);
    handleShowHomeScreenConfirm(false);
  };

  const handleDelete = async () => {
    const URL = `${APIurl}/api/kirtan/delete/${updateKirtanId}`;

    if (sessionStorage.getItem("pinValue")) {
      const delete_kirtan = await api.delete(URL, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token") ? `Bearer ${sessionStorage.getItem("token")}` : "",
        },
        body: JSON.stringify({
          pin: sessionStorage.getItem("pinValue"),
        }),
      });
      const deleteKirtan = await delete_kirtan.json();
      if (deleteKirtan.data?.pin) {
        showAlertToast("warn", deleteKirtan.message);
        sessionStorage.clear();
      } else if (deleteKirtan.status === 200) {
        showAlertToast("success", deleteKirtan.message);
      } else {
        showAlertToast("error", deleteKirtan.message);
      }
      reset(defaultValues);
      setEditorInitialValue(defaultValues.kirtan_content);
      setUpdateKirtanFlag(false);
      setUpdateKirtanId(null);
    } else {
      handlePinModal(true);
      setCreate(false);
    }
    handleShowDeleteConfirm(false);
  };

  const masterData = async () => {
    return new Promise(async (resolve, reject) => {
      const url = `${APIurl}/api/kirtan/masterData-list`;
      const res = await api.get(url);
      const dataList = await res.data.data;
      const bhavArr = await dataList.bhav_list.map((item) => {
        return item.bhav_name;
      });
      setBhavNameArr(bhavArr);
      dispatch(setBookList(dataList.book_list));
      dispatch(setCharList(dataList.char_list));
      dispatch(serRachiytaList(dataList.rachiyta_list));
      dispatch(setBhavList(dataList.bhav_list));
      resolve(true);
    });
  };

  const handleFinalData = async (value) => {
    let condition = value?.flag || false;
    if (condition) {
      const kirtan = value.data;
      const formData = {
        kirtan_title: kirtan.title || "",
        kirtan_tittle_unicode: kirtan.unicode_title || "",
        kirtan_title_english: kirtan.english_title || "",
        kirtan_content: kirtan.content || "",
        kirtan_content_unicode: kirtan.unicode_content || "",
        kirtan_content_english: kirtan.english_content || "",
        book_name: findBookName(kirtan.book_id) || "Kirtanmala-1",
        char_name: findCharName(kirtan.char_id) || "અ",
        raag_name: kirtan.raag_name,
        rachiyta_name: findRachiytaName(kirtan.rachiyta_id) || "Not Available",
        bhav_name_JSON: findBhavNameArr(kirtan.bhavIdArr) || [""],
        seq_number: kirtan.seq_id || "",
        page_number: kirtan.page_no || "",
        pad_number: kirtan.pad_no || "",
        parent_pad_name: (await findParentPadName(kirtan.parent_pad_id)) || "-",
        dhal_name: kirtan?.dhal_name || "",
      };
      reset(formData);
      setEditorInitialValue(formData.kirtan_content);
      setUpdateKirtanId(+kirtan.id);
      setUpdateKirtanFlag(true);
    } else {
      return;
    }
  };

  const handlePinValue = async (value) => {
    sessionStorage.setItem("pinValue", value);
    if (create) await onSubmit();
    else await handleDelete();
  };

  const onSubmit = async () => {
    try {
      const data = {
        kirtan_title: getValues("kirtan_title"),
        kirtan_tittle_unicode: getValues("kirtan_tittle_unicode"),
        kirtan_title_english: getValues("kirtan_title_english"),
        kirtan_content: getValues("kirtan_content"),
        kirtan_content_unicode: getValues("kirtan_content_unicode"),
        kirtan_content_english: getValues("kirtan_content_english"),
        book_name: getValues("book_name"),
        char_name: getValues("char_name"),
        raag_name: getValues("raag_name"),
        rachiyta_name: getValues("rachiyta_name"),
        seq_number: getValues("seq_number"),
        page_number: getValues("page_number"),
        pad_number: getValues("pad_number"),
        parent_pad_name: getValues("parent_pad_name"),
        bhav_name_JSON: getValues("bhav_name_JSON"),
        dhal_name: getValues("dhal_name"),
      };
      if (sessionStorage.getItem("pinValue")?.length > 0) {
        const submittingData = {
          title: data.kirtan_title,
          unicode_title: data.kirtan_tittle_unicode,
          english_title: data.kirtan_title_english,
          content: data.kirtan_content,
          unicode_content: data.kirtan_content_unicode,
          english_content: data.kirtan_content_english,
          page_no: +data.page_number || null,
          seq_id: +data.seq_number || null,
          pad_no: +data.pad_number || null,
          book_id: findBookId(data.book_name) || null,
          parent_pad_id: (await findParentPadId(data.parent_pad_name)) || null,
          char_id: findCharId(data.char_name) || null,
          raag_name: data.raag_name || null,
          bhav_id_arr: findBhavIdArr(data.bhav_name_JSON) || null,
          rachiyta_id: findRachiytaId(data.rachiyta_name) || null,
          dhal_name: data.dhal_name || null,
          pin: sessionStorage.getItem("pinValue"),
        };

        let url = "";
        if (updateKirtanFlag) {
          url = `${APIurl}/api/kirtan/update/${updateKirtanId}`;
        } else {
          url = `${APIurl}/api/kirtan/create`;
        }
        const authToken = sessionStorage.getItem("token");
        axios
          .post(url, submittingData, {
            headers: {
              Authorization: authToken ? `Bearer ${authToken}` : "",
            },
          })
          .then((response) => {
            return response.data;
          })
          .then(async (data) => {
            if (data.data?.pin) {
              showAlertToast("warn", data.message);
              sessionStorage.clear();
            } else if (data.status === 200) {
              showAlertToast("success", data.message);
              let dataIsSet = await fetchData();
              if (dataIsSet) {
                setEditorInitialValue(defaultValues.kirtan_content);
                reset(defaultValues);
                setUpdateKirtanFlag(false);
                setUpdateKirtanId(null);
              }
            } else showAlertToast("error", data.message);
          })
          .catch((error) => {
            showAlertToast("warn", error);
            console.log(error);
          });
      } else {
        handlePinModal(true);
        setCreate(true);
      }
    } catch (error) {
      showAlertToast("warn", error);
      console.log(error);
    }
  };

  const handleKirtanList = async () => {
    let queryString = "";
    if (parentKirtanTitleFilter) queryString += `?kirtan_title=${parentKirtanTitleFilter}&page=${0}&limit=${100}`;
    else queryString += `?page=${0}&limit=${100}`;
    const apiURL = `${APIurl}/api/kirtan/filterList${queryString}`;
    const res = await api.get(apiURL);
    const dataList = res.data.data;
    dispatch(setKirtanList(dataList));
  };

  const fetchData = async () => {
    const dataIsSet = await masterData();
    handleKirtanList();
    return dataIsSet;
  };

  useEffect(() => {
    const myfunction = async () => {
      let dataIsSet = await fetchData();
      setDataSetValue(dataIsSet);
    };
    myfunction();
  }, []);

  useEffect(() => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.clientWidth);
    }
  }, [open]);

  useEffect(() => {
    if (dataSetValue) {
      if (state?.flag) handleFinalData(state);
      else {
        reset(defaultValues);
        setEditorInitialValue(defaultValues.kirtan_content);
        setUpdateKirtanFlag(false);
        setUpdateKirtanId(null);
      }
    }
  }, [dataSetValue]);

  useEffect(() => {
    handleKirtanList();
  }, [parentKirtanTitleFilter]);

  useEffect(() => {
    bookId && findLatestSeqTitle(bookId);
  }, [bookId]);

  useEffect(() => {
    const id = findBookId(watchBookName);
    setBookId(id || 1);
  }, [watchBookName]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {openPin && <PinModal openPin={openPin} handlePinModal={handlePinModal} handlePinValue={handlePinValue} />}
      <div className="flex justify-center items-center w-screen h-screen">
        <div
          className="border-l-stone-950 h-full bg-[#ede5d4] rounded-[10px]  p-2 text-[13px] w-full overflow-auto"
          style={{
            backdropFilter: "blur(10px)",
            border: "2px solid rgba(255, 255, 255, 0.81)",
            boxShadow: "0 0 40px rgba(8,7,16,0.6)",
          }}
        >
          <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
            <div className="flex justify-between items-end mx-4 mt-4 static">
              <Tooltip title="Back To Home" arrow>
                <Button
                  className="h-[40px] z-10 p-0 shadow-lg bg-white mx-3"
                  sx={{ borderRadius: "999px", minWidth: "40px" }}
                  onClick={() => {
                    handleShowHomeScreenConfirm(true);
                  }}
                >
                  <i className="fa-solid fa-arrow-left-long fa-2xl" style={{ fonSize: "1em", lineHeight: ".03125em" }}></i>
                </Button>
              </Tooltip>
              <div className="w-full">
                <h1 className="text-5xl">Kirtan Data</h1>
              </div>
              <div className="flex gap-2">
                <Tooltip title="Save" arrow>
                  <Button type="submit" className="h-[50px] z-10 p-0 shadow-lg bg-white" sx={{ borderRadius: "999px", minWidth: "50px" }}>
                    {<i className="fa-solid fa-check-double fa-2xl text-[#39f33d]"></i>}
                  </Button>
                </Tooltip>
                {!updateKirtanFlag && !isOnlySavePage && (
                  <Tooltip title="Search" arrow>
                    <Button
                      className="h-[50px] z-10 p-0 shadow-lg bg-white"
                      sx={{ borderRadius: "999px", minWidth: "50px" }}
                      onClick={() => {
                        navigate("/search", { state: { oldLocation: "kirtan-data" } });
                      }}
                    >
                      <i className="fa-solid fa-magnifying-glass fa-2xl"></i>
                    </Button>
                  </Tooltip>
                )}
                {updateKirtanFlag && (
                  <>
                    <Tooltip title="Cancel" arrow>
                      <Button
                        className="h-[50px] z-10 p-0 shadow-lg bg-white"
                        sx={{ borderRadius: "999px", minWidth: "50px" }}
                        onClick={() => {
                          handleShowCancelConfirm(true);
                        }}
                      >
                        <i className="fa-regular fa-circle-xmark fa-2xl text-black"></i>
                      </Button>
                    </Tooltip>
                    <Tooltip title="Delete" arrow>
                      <Button
                        className="h-[50px] z-10 p-0 shadow-lg bg-white"
                        sx={{ borderRadius: "999px", minWidth: "50px" }}
                        onClick={() => {
                          handleShowDeleteConfirm(true);
                        }}
                      >
                        <i className="fa-solid fa-trash-can fa-2xl text-[#fd0808]"></i>
                      </Button>
                    </Tooltip>
                  </>
                )}
              </div>
            </div>

            <Box className={`flex flex-col items-center justify-center w-full gap-2 py-3 px-5`}>
              <Box className={`flex flex-row w-full p-[2px] gap-3`}>
                <Box className="w-full">
                  <Typography className="w-full text-[20px] custom-font" sx={{ fontWeight: "700" }}>
                    Kirtan Sulekh Title<sup className="text-red-700">*</sup>{" "}
                  </Typography>
                  <Controller
                    control={control}
                    name="kirtan_title"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        sx={{ borderRadius: "999px" }}
                        InputProps={{
                          style: {
                            fontFamily: "Guj_Gopika_Two_Bold",
                            fontSize: "20px",
                            borderRadius: "999px",
                            backgroundColor: "white",
                          },
                        }}
                        error={!!errors.kirtan_title}
                        helperText={errors?.kirtan_title?.message}
                        onChange={(e) => {
                          handleSulechTitileChange(e.target.value);
                        }}
                        id="Kirtan_Title_Sulekh"
                        size="small"
                        className="w-full my-2 "
                        autoComplete="off"
                      />
                    )}
                  />
                </Box>
                <Box className="w-full">
                  <Typography className="w-full text-[20px] custom-font" sx={{ fontWeight: "700" }}>
                    {" "}
                    Kirtan Unicode Title<sup className="text-red-700">*</sup>{" "}
                  </Typography>
                  <Controller
                    control={control}
                    name="kirtan_tittle_unicode"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        sx={{ borderRadius: "999px" }}
                        InputProps={{
                          style: {
                            fontSize: "20px",
                            borderRadius: "999px",
                            backgroundColor: "white",
                          },
                        }}
                        error={!!errors.kirtan_title}
                        helperText={errors?.kirtan_title?.message}
                        id="Kirtan_Title_Sulekh"
                        size="small"
                        className="w-full my-2 "
                        autoComplete="off"
                      />
                    )}
                  />
                </Box>
                <Box className="w-full">
                  <Box className={`w-full`}>
                    <Typography className="w-full text-[20px] custom-font" sx={{ fontWeight: "700" }}>
                      {" "}
                      Kirtan English Title<sup className="text-red-700">*</sup>{" "}
                    </Typography>
                    <Controller
                      control={control}
                      name="kirtan_title_english"
                      render={({ field }) => (
                        <TextField
                          {...field}
                          sx={{ borderRadius: "999px" }}
                          InputProps={{
                            style: {
                              fontSize: "20px",
                              borderRadius: "999px",
                              backgroundColor: "white",
                            },
                          }}
                          error={!!errors.kirtan_title}
                          helperText={errors?.kirtan_title?.message}
                          id="kirtan_title_english"
                          size="small"
                          className="w-full my-2 "
                          autoComplete="off"
                        />
                      )}
                    />
                  </Box>
                </Box>
              </Box>

              <Box className={`flex flex-row w-full p-[2px] gap-3 h-auto`}>
                <Box className={`w-full`}>
                  <Typography className="w-full text-[20px]" sx={{ fontWeight: "700" }}>
                    {" "}
                    Kirtan Sulekh Content<sup className="text-red-700">*</sup>{" "}
                  </Typography>
                  <div className="mt-2">
                    <Editor
                      tinymceScriptSrc={localTinyMCEScriptSrc}
                      init={{
                        menubar: false,
                        toolbar: [
                          { name: "history", items: ["undo", "redo"] },
                          { name: "fontFamily", items: ["fontFamily"] },
                          { name: "formatting", items: ["bold", "italic", "underline"] },
                          { name: "forecolor", items: ["forecolor"] },
                          { name: "customColors", items: ["redGhanu", "purpleGhanu", "redGyan", "purpleGyan"] },
                        ],
                        setup: (editor) => {
                          // Inject custom CSS for button styling
                          editor.on("init", () => {
                            const styleEl = document.createElement("style");
                            styleEl.innerHTML = `
                button[aria-label="Red-Ghanu"] {
                  background-color: #900000 !important;
                  color: white !important;
                  border: none !important;
                  padding: 4px 8px !important;
                }
                button[aria-label="Red-Ghanu"]:hover {
                  background-color: #b00000 !important;
                }
                button[aria-label="Purple-Ghanu"] {
                  background-color: #0003AA !important;
                  color: white !important;
                  border: none !important;
                  padding: 4px 8px !important;
                }
                button[aria-label="Purple-Ghanu"]:hover {
                  background-color: #2020cc !important;
                }
                button[aria-label="Red-Gyan"] {
                  background-color: #900000 !important;
                  color: white !important;
                  border: none !important;
                  padding: 4px 8px !important;
                }
                button[aria-label="Red-Gyan"]:hover {
                  background-color: #b00000 !important;
                }
                button[aria-label="Purple-Gyan"] {
                  background-color: #0003AA !important;
                  color: white !important;
                  border: none !important;
                  padding: 4px 8px !important;
                }
                button[aria-label="Purple-Gyan"]:hover {
                  background-color: #2020cc !important;
                }
              `;
                            document.head.appendChild(styleEl);
                          });

                          // Red button with Ghanu_unicode_Guj font
                          editor.ui.registry.addButton("redGhanu", {
                            text: "ગુજ",
                            tooltip: "Red-Ghanu",
                            onAction: () => {
                              editor.formatter.apply("redGhanuFormat");
                            },
                          });

                          // Purple button with Ghanu_unicode_bold_Guj font
                          editor.ui.registry.addButton("purpleGhanu", {
                            text: "ગુજ",
                            tooltip: "Purple-Ghanu",
                            onAction: () => {
                              editor.formatter.apply("purpleGhanuFormat");
                            },
                          });

                          editor.ui.registry.addButton("redGyan", {
                            text: "હિન્દી",
                            tooltip: "Red-Gyan",
                            onAction: () => {
                              editor.formatter.apply("redGyanFormat");
                            },
                          });

                          // Purple button with Ghanu_unicode_bold_Guj font
                          editor.ui.registry.addButton("purpleGyan", {
                            text: "હિન્દી",
                            tooltip: "Purple-Gyan",
                            onAction: () => {
                              editor.formatter.apply("purpleGyanBoldFormat");
                            },
                          });

                          // Register custom formats
                          editor.on("init", () => {
                            editor.formatter.register("redGhanuFormat", {
                              inline: "span",
                              styles: {
                                color: "#900000",
                                fontFamily: "Ghanu_unicode_bold_Guj",
                              },
                            });

                            editor.formatter.register("purpleGhanuFormat", {
                              inline: "span",
                              styles: {
                                color: "#0003AA",
                                fontFamily: "Ghanu_unicode_bold_Guj",
                              },
                            });

                            editor.formatter.register("redGyanFormat", {
                              inline: "span",
                              styles: {
                                color: "#900000",
                                fontFamily: "Gyan_Uni_Bold_Hindi",
                              },
                            });

                            editor.formatter.register("purpleGyanBoldFormat", {
                              inline: "span",
                              styles: {
                                color: "#0003AA",
                                fontFamily: "Gyan_Uni_Bold_Hindi",
                              },
                            });
                          });
                        },
                        font_family_formats: `
                          Guj_Gopika_Two_Bold=ગુજ-ગોપિકા-ટૂ-બોલ્ડ;
                          Hin_CC-Devnagri_Bold_SULEKH=હિન-સીસી-દેવનાગરી-બોલ્ડ-સુલેખ;
                          AA_Sanskrut_Jodaxar_B_SULEKH=સંસ્કૃત-જોડાક્ષર-બી-સુલેખ;
                          Ghanu_unicode_Guj=Ghanu_unicode_Guj;
                          Ghanu_unicode_bold_Guj=Ghanu_unicode_bold_Guj;
                          Gyan_Uni_Bold_Hindi=Gyan_Uni_Bold_Hindi;
                          UH002 SanskritText-Regular=સંસ્કૃત ટેક્સ્ટ-સામાન્ય;
                          UH002 SanskritText-Bold=સંસ્કૃત ટેક્સ્ટ-બોલ્ડ;`,
                        tinycomments_mode: "embedded",
                        tinycomments_author: "Author name",
                        mergetags_list: [
                          { value: "First.Name", title: "First Name" },
                          { value: "Email", title: "Email" },
                        ],
                        ai_request: (request, respondWith) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
                        height: "640px",
                        borderRadius: "9999px !important",
                        content_style: content_style,
                      }}
                      initialValue={editorInitialValue}
                      onEditorChange={(content, editor) => {
                        handleSulechContentChange(editor);
                      }}
                    />
                  </div>
                </Box>
                <Box className={`w-full`}>
                  <Typography className="w-full text-[20px]" sx={{ fontWeight: "700" }}>
                    {" "}
                    Kirtan Unicode Content<sup className="text-red-700">*</sup>{" "}
                  </Typography>
                  <Controller
                    control={control}
                    name="kirtan_content_unicode"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        sx={{ borderRadius: "25px" }}
                        id="Kirtan_Sulekh"
                        InputProps={{
                          style: {
                            fontSize: "20px",
                            borderRadius: "25px",
                            backgroundColor: "white",
                          },
                        }}
                        error={!!errors.kirtan_content}
                        helperText={errors?.kirtan_content?.message}
                        className="w-full my-2 "
                        autoComplete="off"
                        multiline
                        rows="21"
                      />
                    )}
                  />
                </Box>
                <Box className={`w-full`}>
                  <Typography className="w-full text-[20px]" sx={{ fontWeight: "700" }}>
                    {" "}
                    Kirtan English Content<sup className="text-red-700">*</sup>{" "}
                  </Typography>
                  <Controller
                    control={control}
                    name="kirtan_content_english"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        sx={{ borderRadius: "25px" }}
                        id="Kirtan_Sulekh"
                        InputProps={{
                          style: {
                            fontSize: "20px",
                            borderRadius: "25px",
                            backgroundColor: "white",
                          },
                        }}
                        error={!!errors.kirtan_content}
                        helperText={errors?.kirtan_content?.message}
                        className="w-full my-2 "
                        autoComplete="off"
                        multiline
                        rows="21"
                      />
                    )}
                  />
                </Box>
              </Box>

              <Box className={`relative flex flex-row items-start justify-start w-full p-[2px] gap-4 flex-wrap `}>
                <Box className={`flex flex-col p-[2px] w-[23.5%]`}>
                  <Typography className="w-full text-[20px]" sx={{ fontWeight: "700" }}>
                    {" "}
                    Book<sup className="text-red-700">*</sup>
                  </Typography>
                  <Controller
                    control={control}
                    name="book_name"
                    render={({ field }) => (
                      <Select
                        {...field}
                        className="text-[15px] font-[600] w-full my-2 bg-white"
                        error={!!errors.book_name}
                        helperText={errors?.book_name?.message}
                        value={field.value}
                        size="small"
                        sx={{ ":focus": { outline: "none" }, outline: "none", borderRadius: "25px" }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: "220px", // Set your desired height here
                            },
                          },
                        }}
                      >
                        <MenuItem value="Not Available">Not Available</MenuItem>
                        {bookList.map((book) => (
                          <MenuItem key={book.id} value={book.name}>
                            {book.name}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                </Box>

                <Box className={`flex flex-col p-[2px] w-[23.5%]`}>
                  <Typography className="w-full text-[20px]" sx={{ fontWeight: "700" }}>
                    Character<sup className="text-red-700">*</sup>
                  </Typography>
                  <Controller
                    control={control}
                    name="char_name"
                    render={({ field }) => (
                      <Select
                        {...field}
                        value={field.value}
                        className="text-[15px] font-[600]  my-2 w-full bg-white"
                        size="small"
                        sx={{ ":focus": { outline: "none" }, outline: "none", borderRadius: "25px" }}
                        error={!!errors.char_name}
                        helperText={errors?.char_name?.message}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: "250px", // Set your desired height here
                            },
                          },
                        }}
                      >
                        <MenuItem value="Not Available">Not Available</MenuItem>
                        {charList.map((char) => (
                          <MenuItem key={char.id} value={char.guj_char}>
                            {char.guj_char}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                </Box>

                <Box className={`flex flex-col p-[2px] w-[23.5%]`}>
                  <Typography className="w-full text-[20px]" sx={{ fontWeight: "700" }}>
                    Rachiyta
                  </Typography>
                  <Controller
                    control={control}
                    name="rachiyta_name"
                    render={({ field }) => (
                      <Select
                        {...field}
                        value={field.value}
                        className="text-[15px] font-[600] w-full my-2 bg-white"
                        size="small"
                        sx={{ ":focus": { outline: "none" }, outline: "none", borderRadius: "25px" }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: "250px", // Set your desired height here
                            },
                          },
                        }}
                      >
                        <MenuItem value="Not Available">Not Available</MenuItem>
                        {rachiytaList.map((rachiyta) => (
                          <MenuItem key={rachiyta.id} value={rachiyta.name}>
                            {rachiyta.name}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                </Box>

                <Box className={`flex flex-col p-[2px] w-[23.5%]`}>
                  <Typography className="w-full text-[20px]" sx={{ fontWeight: "700" }}>
                    {" "}
                    Raag
                  </Typography>
                  <Controller
                    control={control}
                    name="raag_name"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        sx={{
                          borderRadius: "25px",
                          "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button": {
                            "-webkit-appearance": "none",
                            margin: 0,
                          },
                          "& input[type=number]": {
                            "-moz-appearance": "textfield", // Firefox
                          },
                        }}
                        InputProps={{
                          style: {
                            fontFamily: "Guj_Gopika_Two_Bold",
                            borderRadius: "25px",
                            backgroundColor: "white",
                          },
                        }}
                        id="Kirtan_raag_name"
                        size="small"
                        className="w-full my-2 "
                        autoComplete="off"
                      />
                    )}
                  />
                </Box>
                {bookId && (
                  <Box className={`absolute flex flex-col p-[2px] w-auto -bottom-4`}>
                    <Typography className="w-full text-[20px] text-center flex justify-center items-center text-red-600" sx={{ fontWeight: "700" }}>
                      {`#${findBookName(latestSeqObj?.book_id)}-${latestSeqObj?.seq_id}`}
                      <span className="pl-2" style={{ fontFamily: "Guj_Gopika_Two_Bold" }}>{`${latestSeqObj?.title}`}</span>{" "}
                    </Typography>
                  </Box>
                )}
              </Box>

              <Box className={`flex flex-row justify-start items-start w-full p-[2px] gap-4 flex-wrap`}>
                <Box className={`flex flex-col  p-[2px] w-[23.5%]`}>
                  <Typography className="w-full text-[20px]" sx={{ fontWeight: "700" }}>
                    Sequence Id<sup className="text-red-700">*</sup>
                  </Typography>
                  <Controller
                    control={control}
                    name="seq_number"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        placeholder="Enter a sequence number"
                        sx={{
                          borderRadius: "25px",
                          "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button": {
                            "-webkit-appearance": "none",
                            margin: 0,
                          },
                          "& input[type=number]": {
                            "-moz-appearance": "textfield", // Firefox
                          },
                        }}
                        InputProps={{
                          style: {
                            borderRadius: "25px",
                            backgroundColor: "white",
                          },
                          inputProps: {
                            onWheel: (event) => event.currentTarget.blur(),
                          },
                        }}
                        error={!!errors.seq_number}
                        helperText={errors?.seq_number?.message}
                        id="Kirtan_Title_Sulekh"
                        size="small"
                        className="w-full my-2 "
                        autoComplete="off"
                        type="number"
                      />
                    )}
                  />
                </Box>

                <Box className={`flex flex-col  p-[2px] w-[23.5%]`}>
                  <Typography className="w-full text-[20px]" sx={{ fontWeight: "700" }}>
                    Page Number<sup className="text-red-700">*</sup>
                  </Typography>
                  <Controller
                    control={control}
                    name="page_number"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        sx={{
                          borderRadius: "25px",
                          "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button": {
                            "-webkit-appearance": "none",
                            margin: 0,
                          },
                          "& input[type=number]": {
                            "-moz-appearance": "textfield", // Firefox
                          },
                        }}
                        placeholder="Enter a page number"
                        InputProps={{
                          style: {
                            borderRadius: "25px",
                            backgroundColor: "white",
                          },
                          inputProps: {
                            onWheel: (event) => event.currentTarget.blur(),
                          },
                        }}
                        error={!!errors.page_number}
                        helperText={errors?.page_number?.message}
                        id="Kirtan_Title_Sulekh"
                        size="small"
                        className="w-full my-2 "
                        autoComplete="off"
                        type="number"
                      />
                    )}
                  />
                </Box>

                <Box className={`flex flex-col p-[2px] w-[23.5%]`}>
                  <Typography className="w-[200px] text-[20px]" sx={{ fontWeight: "700" }}>
                    Pad Number
                  </Typography>
                  <Controller
                    control={control}
                    name="pad_number"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        sx={{
                          borderRadius: "25px",
                          "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button": {
                            "-webkit-appearance": "none",
                            margin: 0,
                          },
                          "& input[type=number]": {
                            "-moz-appearance": "textfield", // Firefox
                          },
                        }}
                        InputProps={{
                          style: {
                            borderRadius: "25px",
                            backgroundColor: "white",
                          },
                          inputProps: {
                            onWheel: (event) => event.currentTarget.blur(),
                          },
                        }}
                        id="Kirtan_Title_Sulekh"
                        size="small"
                        className="w-full my-2 "
                        autoComplete="off"
                        type="number"
                      />
                    )}
                  />
                </Box>

                <Box className={`flex flex-col p-[2px] w-[23.5%]`}>
                  <Typography className="w-[200px] text-[20px]" sx={{ fontWeight: "700" }}>
                    Dhal Name
                  </Typography>
                  <Controller
                    control={control}
                    name="dhal_name"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        sx={{
                          borderRadius: "25px",
                          "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button": {
                            "-webkit-appearance": "none",
                            margin: 0,
                          },
                          "& input[type=number]": {
                            "-moz-appearance": "textfield", // Firefox
                          },
                        }}
                        InputProps={{
                          style: {
                            fontFamily: "Guj_Gopika_Two_Bold",
                            borderRadius: "25px",
                            backgroundColor: "white",
                          },
                          inputProps: {
                            onWheel: (event) => event.currentTarget.blur(),
                          },
                        }}
                        id="Kirtan_Title_Sulekh"
                        size="small"
                        className="w-full my-2 "
                        autoComplete="off"
                      />
                    )}
                  />
                </Box>
              </Box>

              <Box className="w-full">
                {kirtanList && (
                  <Box className={`flex flex-row p-[2px] items-center justify-center`}>
                    <Typography className="w-[25%] text-[20px]" sx={{ fontWeight: "700" }}>
                      1<sup>st</sup> Pad Title
                    </Typography>
                    <Button
                      ref={buttonRef}
                      className="text-black my-2 w-full p-0 h-[39px] bg-white"
                      sx={{
                        textTransform: "none",
                        borderRadius: "25px",
                        color: "black",
                        fontWeight: "500",
                        fontFamily: getValues("parent_pad_name") === "Not Available" ? null : "Guj_Gopika_Two_Bold",
                        fontSize: "18px",
                        border: "1px solid #bebebe",
                      }}
                      size="small"
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleClick}
                    >
                      {getValues("parent_pad_name")}
                    </Button>
                    <Controller
                      control={control}
                      name="parent_pad_name"
                      render={({ field }) => (
                        <Menu
                          {...field}
                          size="small"
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                            style: { textAlign: "center", maxHeight: "400px" },
                          }}
                        >
                          <TextField
                            InputProps={{
                              style: {
                                borderRadius: "25px",
                              },
                            }}
                            className="w-full"
                            autoComplete="off"
                            onKeyDown={(e) => e.stopPropagation()}
                            size="small"
                            value={parentKirtanTitleFilter}
                            onChange={handleParentKirtanTitleFilter}
                            name="webControllerUrl"
                          />
                          <MenuItem
                            style={{ justifyContent: "center", fontSize: "18px", width: buttonWidth + "px", fontWeight: "300" }}
                            onClick={() => {
                              setAnchorEl(null);
                              setValue("parent_pad_name", "Not Available");
                            }}
                            value={"Not Available"}
                          >
                            Not Available
                          </MenuItem>
                          {kirtanList &&
                            kirtanList.map((kirtan) => {
                              return (
                                <MenuItem
                                  style={{ justifyContent: "center" }}
                                  onClick={() => {
                                    setAnchorEl(null);
                                    setValue("parent_pad_name", kirtan.title);
                                  }}
                                  value={kirtan.title}
                                >
                                  {
                                    <p>
                                      {`${findBookName(kirtan.book_id)}-${kirtan.seq_id}`} -{" "}
                                      <span
                                        style={{ fontFamily: "Guj_Gopika_Two_Bold", width: buttonWidth + "px", fontWeight: "300", fontSize: "20px" }}
                                      >
                                        {kirtan.title}
                                      </span>
                                    </p>
                                  }
                                </MenuItem>
                              );
                            })}
                        </Menu>
                      )}
                    />
                  </Box>
                )}
                <Box>
                  <Box className={`flex flex-row p-[2px] items-center justify-between`}>
                    <Typography className="text-[20px] w-[25%]" sx={{ fontWeight: "700" }}>
                      Bhav Names<sup className="text-red-700">*</sup>
                    </Typography>
                    <Controller
                      name="bhav_name_JSON" // Name of your form field
                      control={control}
                      // defaultValue={[]} // Default value, should be an array for multiple selection
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          sx={{ m: 1, width: "100%", margin: "0px", borderRadius: "999px" }}
                          className="bg-white"
                          size="small"
                          multiple
                          options={bhavNameArr}
                          getOptionLabel={(option) => option}
                          disableCloseOnSelect
                          onChange={(event, newValue) => field.onChange(newValue)} // Pass the new value to the field's onChange function
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select Bhav Name"
                              sx={{
                                ".MuiOutlinedInput-root": {
                                  // Targeting the root of the outlined input
                                  borderRadius: "25px", // Apply your desired borderRadius
                                },
                              }}
                            />
                          )}
                          renderOption={(props, option, { selected }) => (
                            <MenuItem {...props}>
                              {option}
                              {selected ? <CheckIcon color="info" /> : null}
                            </MenuItem>
                          )}
                        />
                      )}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </form>
        </div>
        <ConfirmBox
          open={showHomeScreenConfirm}
          handleClose={handleShowHomeScreenConfirm}
          handleConfirm={handleHome}
          title={"Confirm HomeScreen"}
          msg={"Are you sure you want to go back to the home page?"}
        />
        {/* <ConfirmBox
                    open={showSaveConfirm}
                    handleClose={handleShowSaveConfirm}
                    handleConfirm={onSubmit}
                /> */}
        <ConfirmBox
          open={showCancelConfirm}
          handleClose={handleShowCancelConfirm}
          handleConfirm={handleCancel}
          title={"Confirm Cancellation"}
          msg={"Are you sure you want to cancel? Any unsaved changes will be lost."}
        />
        <ConfirmBox
          open={showDeleteConfirm}
          handleClose={handleShowDeleteConfirm}
          handleConfirm={handleDelete}
          title={"Confirm Deletion"}
          msg={"Are you sure you want to delete this Kirtan?"}
          type={"delete"}
        />
      </div>
    </>
  );
};

export default DatabaseForm;
